import { render } from "./SingleEntityTable.vue?vue&type=template&id=48f474ee"
import script from "./SingleEntityTable.vue?vue&type=script&lang=js"
export * from "./SingleEntityTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vdzeer/Projects/movesmart-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__